export const AVAILABLE_MODE = ['LINK','QR'];

// export const getCurrentUrl = () =>  new URL(window.location.href);

// export const getMode = (mode) => {
    
//     const mode = mode.searchParams.get('mode');
//     return mode?.toUpperCase();
// }